var _g;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCodingQuestionIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "32px",
    height: "29px",
    viewBox: "0 0 32 29",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Group 11 Copy") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Configurations",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-11-Copy"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-14"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    stroke: "#00B7A4",
    strokeWidth: 1.76,
    x: 0.88,
    y: 0.88,
    width: 30.24,
    height: 27.24,
    rx: 2.4
  }), /*#__PURE__*/React.createElement("line", {
    x1: 0,
    y1: 8.56818182,
    x2: 32,
    y2: 8.56818182,
    id: "Path-12",
    stroke: "#00B7A4",
    strokeWidth: 1.76
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12,11.8636364 L7.24211447,16.567455 C6.92791491,16.8780841 6.92502049,17.3846078 7.2356496,17.6988074 C7.23779223,17.7009746 7.23994722,17.7031296 7.24211447,17.7052723 L12,22.4090909 L12,22.4090909",
    id: "Path-13",
    stroke: "#00B7A4",
    strokeWidth: 1.76,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.3333333,11.8636364 L20.5754478,16.567455 C20.2612482,16.8780841 20.2583538,17.3846078 20.5689829,17.6988074 C20.5711256,17.7009746 20.5732806,17.7031296 20.5754478,17.7052723 L25.3333333,22.4090909 L25.3333333,22.4090909",
    id: "Path-13-Copy",
    stroke: "#00B7A4",
    strokeWidth: 1.76,
    strokeLinecap: "round",
    transform: "translate(22.666667, 17.136364) scale(-1, 1) translate(-22.666667, -17.136364) "
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.1848617,19.7384654 L16.7452693,19.7384654 L16.7452693,21.0909091 L15.1848617,21.0909091 L15.1848617,19.7384654 Z M13.3333333,15.8217883 C13.3333333,15.4250715 13.3973799,15.0644198 13.5254731,14.7398334 C13.6535662,14.4152469 13.8398836,14.1375451 14.084425,13.906728 C14.3289665,13.675911 14.6239689,13.4973884 14.9694323,13.3711603 C15.3148957,13.2449322 15.701116,13.1818182 16.1280932,13.1818182 C16.4852014,13.1818182 16.8170791,13.2305062 17.1237263,13.3278821 C17.4303736,13.4252581 17.6982048,13.5659122 17.9272198,13.7498445 C18.1562348,13.9337769 18.3367297,14.1627907 18.4687045,14.436886 C18.6006793,14.7109812 18.6666667,15.0211416 18.6666667,15.3673672 C18.6666667,15.6198234 18.6375546,15.8380177 18.5793304,16.02195 C18.5211063,16.2058824 18.443474,16.3645691 18.3464338,16.4980102 C18.2493935,16.6314513 18.1387676,16.7504664 18.014556,16.8550553 C17.8903445,16.9596443 17.7661329,17.06243 17.6419214,17.1634125 C17.4944202,17.278821 17.3585638,17.3906231 17.2343523,17.4988186 C17.1101407,17.6070141 17.0014556,17.7278324 16.9082969,17.8612735 C16.8151383,17.9947146 16.7433285,18.1515981 16.6928675,18.3319239 C16.6424066,18.5122497 16.6171761,18.7322472 16.6171761,18.9919164 L15.3595342,18.9919164 C15.3595342,18.674543 15.3770015,18.4058575 15.411936,18.18586 C15.4468705,17.9658625 15.5031538,17.7729138 15.580786,17.6070141 C15.6584182,17.4411143 15.7535177,17.2950504 15.8660844,17.1688223 C15.9786511,17.0425942 16.1125667,16.9181694 16.2678311,16.7955478 C16.3920427,16.6945654 16.5104318,16.6007959 16.6229985,16.5142395 C16.7355653,16.4276831 16.8364871,16.3321104 16.9257642,16.2275215 C17.0150412,16.1229325 17.0849102,16.0057207 17.1353712,15.8758861 C17.1858321,15.7460515 17.2110626,15.5909713 17.2110626,15.4106454 C17.2110626,15.1942544 17.1703057,15.0085188 17.0887918,14.8534386 C17.007278,14.6983584 16.9082969,14.5739336 16.7918486,14.4801642 C16.6754003,14.3863947 16.5511887,14.3178709 16.419214,14.2745927 C16.2872392,14.2313145 16.1707909,14.2096754 16.069869,14.2096754 C15.5885492,14.2096754 15.2333819,14.3557393 15.0043668,14.6478672 C14.7753518,14.939995 14.6608443,15.3313021 14.6608443,15.8217883 L13.3333333,15.8217883 Z",
    id: "Shape",
    fill: "#000000",
    fillRule: "nonzero"
  })), /*#__PURE__*/React.createElement("g", {
    id: "?",
    transform: "translate(13.333333, 13.181818)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCodingQuestionIcon);
export default __webpack_public_path__ + "static/media/CodingQuestionIcon.f6fe0a5a.svg";
export { ForwardRef as ReactComponent };